
























































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { Department, PatientInfoModel } from "@/types/aznconnect_api";
import { LabeledText, NamedValue } from "@/types/types";
import InformationCard from "@/components/InformationCard.vue";
import InformationCardValues from "@/components/InformationCardValues.vue";
import { AZNCONNECT_API } from "@/services/aznconnect-api";
import { Getter } from "vuex-class";
import { ApplicationConfiguration } from "@/types/store";

@Component({
  components: {
    "information-card": InformationCard,
    "information-card-values": InformationCardValues,
  },
})
export default class DefaultPatientSearchDialog extends Vue {
  @Prop({ default: null })
  referralId!: string;

  // PatientInfoModel property is set later
  patientInfo?: any = null;

  @Prop({ default: false })
  value!: boolean;

  @Watch("value") onValueChanged(val: boolean, oldVal: boolean) {
    if (val) {
      this.loadPatientData(this.referralId);
    } else {
      this.clearSearchData();
    }
  }

  @Getter("applicationConfiguration")
  applicationConfiguration!: ApplicationConfiguration;

  loading: boolean = false;
  searching: boolean = false;
  storingPatientNumber: boolean = false;
  storingPatientNumberError: string = "";
  patientNumber: string = "";
  patientBsn: string = "";
  patientName: string = "";
  patientBirthDate: string = "";
  validationMessages: Array<string> = [];
  errorMessages: Array<string> = [];
  searchResults: Array<any> = [];
  selectedSearchResult: any = {};

  departments: Array<any> = [];
  selectedDepartmentCode: string = "";

  get show(): boolean {
    return this.value;
  }

  set show(value: boolean) {
    this.$emit("input", value);
  }

  get dialogPatientInformationValues(): Array<LabeledText> {
    const formatDate = Vue.filter("formatDate");

    const values: Array<LabeledText> = [];
    if (this.patientInfo) {
      values.push(
        new LabeledText(
          "Patiëntnummer",
          this.patientInfo.PatientNumber || "Onbekend",
        ),
      );
      values.push(new LabeledText("Bsn", this.patientInfo.Bsn || "Onbekend"));
      values.push(
        new LabeledText(
          "Geboortedatum",
          formatDate(this.patientInfo.BirthDate),
        ),
      );
      values.push(
        new LabeledText(
          "Adres",
          `${this.patientInfo.Street} ${this.patientInfo.HouseNumber}, ${
            this.patientInfo.PostalCode
          } ${this.patientInfo.City}`,
        ),
      );
    }
    return values;
  }

  get hasPatientSelected(): boolean {
    return this.selectedSearchResult && this.selectedSearchResult.PatientNumber;
  }

  get isSearchByPatientNumber(): boolean {
    return this.patientNumber != "" && this.patientNumber != null;
  }

  get isSearchByPatientBsn(): boolean {
    return this.patientBsn != "" && this.patientBsn != null;
  }

  get isLinkPatientNumberAllowed(): boolean {
    return (
      this.selectedSearchResult.PatientNumber &&
      this.selectedSearchResult.PatientNumber != this.patientInfo.PatientNumber
    );
  }

  initializeSearchData(patient?: PatientInfoModel): void {
    const formatDate = Vue.filter("formatDate");
    if (patient) {
      this.patientNumber = patient.PatientNumber || "";
      this.patientBsn = patient.Bsn || "";

      let birthNameParts = patient.FamilyName.split("-");
      const birthName = birthNameParts[birthNameParts.length - 1].trim();
      birthNameParts = birthName.split(" ");
      const birthNameWithoutPrefix = birthNameParts[birthNameParts.length - 1];

      this.patientName = birthNameWithoutPrefix;
      this.patientBirthDate = formatDate(patient.BirthDate);
    } else {
      this.clearSearchData();
    }
  }

  clearSearchData(): void {
    this.patientNumber = "";
    this.patientBsn = "";
    this.patientName = "";
    this.patientBirthDate = "";

    this.clearSearchResults();
  }

  clearSearchResults(): void {
    this.selectedSearchResult = {};
    this.searchResults = [];
    this.validationMessages = [];
    this.errorMessages = [];
  }

  loadPatientData(reference: string) {
    this.loading = true;
    const vm = this;
    AZNCONNECT_API.get("/patient/Get", {
      params: { referenceId: reference },
    }).then(
      function(response) {
        var patientInfoObj = response.data as PatientInfoModel;
        vm.patientInfo = patientInfoObj;
        vm.loading = false;

        vm.initializeSearchData(vm.patientInfo);
        vm.search();

        if (
          vm.applicationConfiguration.patientNumberDepartmentOverruleEnabled
        ) {
          vm.loadAllDepartments().then(vm.loadSelectedDepartment);
        }
      },
      function(response) {
        // error callback
        vm.loading = false;
      },
    );
  }

  // Retrieves all available departments
  async loadAllDepartments() {
    const vm = this;

    return AZNCONNECT_API.get("/Settings/AllDepartments").then(
      function(response) {
        // eslint-disable-next-line no-console
        const apiDepartments: Array<Department> = response.data as Array<
          Department
        >;
        const departments: Array<NamedValue> = [];
        for (const apiDepartment of apiDepartments) {
          departments.push(
            new NamedValue(apiDepartment.code, apiDepartment.description),
          );
        }
        vm.departments = departments;
      },
      function(response) {
        // error callback
        // eslint-disable-next-line no-console
        console.error("Unable to load departments");
      },
    );
  }

  //Retrieves the department that is linked to the referral, based on the department that was assigned by the referrer
  loadSelectedDepartment() {
    const vm = this;
    return AZNCONNECT_API.get("/Referral/Department", {
      params: { id: vm.referralId },
    }).then(
      function(response) {
        // eslint-disable-next-line no-console
        const apiDepartment: Department = response.data as Department;
        vm.selectedDepartmentCode = apiDepartment.code;
      },
      function(response) {
        // error callback
        // eslint-disable-next-line no-console
        console.error(
          `Unable to load a selected-department for referral ${vm.referralId}`,
        );
      },
    );
  }

  search() {
    this.clearSearchResults();
    this.searching = true;
    this.storingPatientNumberError = "";

    const vm = this;
    AZNCONNECT_API.post("/Patient/Search", {
      fieldEncounterId: this.referralId,
      patientNumber: this.applicationConfiguration
        .patientSearchByPatientNrEnabled
        ? this.patientNumber
        : "",
      patientBsn: this.applicationConfiguration.patientSearchByPatientBsnEnabled
        ? this.patientBsn
        : "",
      patientName: this.applicationConfiguration
        .patientSearchByFamilyNameEnabled
        ? this.patientName
        : "",
      patientBirthDate: this.applicationConfiguration
        .patientSearchByBirthDateEnabled
        ? this.patientBirthDate
        : "",
    }).then(
      function(response) {
        vm.errorMessages = response.data.ErrorMessages;
        vm.validationMessages = response.data.ValidationMessages;
        vm.searchResults = response.data.Results;
        vm.searching = false;
      },
      function(response) {
        // error callback
        vm.searching = false;
      },
    );
  }

  storePatientNumber() {
    if (this.selectedSearchResult.PatientNumber) {
      this.storingPatientNumber = true;
      this.storingPatientNumberError = "";

      const vm = this;
      const patientNumber = this.selectedSearchResult.PatientNumber;
      const bsnHospital = this.selectedSearchResult.Bsn;
      AZNCONNECT_API.post("/Patient/StorePatientNumber", {
        fieldEncounterId: this.referralId,
        patientNumber: patientNumber,
        bsnHospital: bsnHospital,
        destinationDepartmentCode: this.selectedDepartmentCode
          ? this.selectedDepartmentCode
          : null,
      }).then(
        function(response) {
          vm.patientInfo.PatientNumber = patientNumber;
          vm.storingPatientNumber = false;
          vm.closeDialog();
        },
        function(data) {
          vm.storingPatientNumber = false;
          vm.storingPatientNumberError = data.response.statusText;
        },
      );
    }
  }

  closeDialog(): void {
    this.show = false;
  }
}
